import React, { useEffect, useState } from "react";
import { ConfigProvider } from "antd";
import dayjs from "@dayjs";
import updateLocale from "dayjs/plugin/updateLocale";

import "antd/dist/reset.css";
import "../../DatePicker/index.css";
import getDeviceType from "@/app/utils/device/getDeviceType";
import { useTheme } from "next-themes";
import MobileCalendars from "./MobileCalendars";
import DesktopCalendars from "./DesktopCalendars";
import type { FlightSearchRequest } from "@/types/flights";

// to start schema from monday instead of sunday
dayjs.extend(updateLocale);
dayjs.updateLocale("en", {
  weekStart: 1,
});

type Props = {
  departOnly?: boolean;
  departDate: string;
  returnDate: string;
  updateFlightField: (
    flightId: string,
    updatedFields: Partial<FlightSearchRequest>
  ) => void;
  flightId: string;
};

const CustomDatePicker = ({
  departOnly,
  departDate,
  returnDate,
  updateFlightField,
  flightId,
}: Props) => {
  const { resolvedTheme } = useTheme();
  const [deviceType, setDeviceType] = useState({
    isMobileType: false,
    isTabletType: false,
  });

  useEffect(() => {
    setDeviceType(getDeviceType());
  }, []);

  const shouldRenderMobile = deviceType.isMobileType || deviceType.isTabletType;

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#42E6FF",
          colorBgContainer: resolvedTheme == "light" ? "#fafafa" : "#09090b",
          colorText: resolvedTheme == "light" ? "#3f3f46" : "white",
          colorBgElevated: resolvedTheme == "light" ? "white" : "black",
          colorTextDisabled: "grey",
          colorBorderSecondary:
            resolvedTheme == "light" ? "#a1a1aa" : "#ffffff80",
        },
      }}
    >
      {shouldRenderMobile ? (
        <MobileCalendars
          departOnly={departOnly}
          departDate={departDate}
          returnDate={returnDate}
          updateFlightField={updateFlightField}
          flightId={flightId}
        />
      ) : (
        <DesktopCalendars
          departOnly={departOnly}
          departDate={departDate}
          returnDate={returnDate}
          updateFlightField={updateFlightField}
          flightId={flightId}
        />
      )}
    </ConfigProvider>
  );
};

export default CustomDatePicker;
